'use client';

import { useContext } from 'react';
import { I18nContext, type I18nContextType } from './I18nProvider';

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);

  if (context == null) {
    throw new Error('useI18n hook was used without I18nProvider.');
  }

  return context;
};

export { I18nProvider } from './I18nProvider';
